
let logBatch: MarketplaceEvent[] = [];
const SESSION_ID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

const MAX_SIZE_MB = 1;
const SIZE_THRESHOLD_BYTES = MAX_SIZE_MB * 1024 * 1024; // 1MB in bytes

type MarketplaceEvent = {
	sessionId: string;
	timestamp: string;
	action: string;
	detail: string | object;
	andeeId: string | null;
	visitorId: string | null;
	ip: string | null;
	userAgent: string | null;
};

export function createTracker(andee: any, sessionInfo: any) {
	return function trackEvent(action: string, detail: object | string) {
		const event: MarketplaceEvent = {
			sessionId: SESSION_ID,
			action,
			detail: detail,
			andeeId: andee?.personId || andee?.id || andee?.andeeId || null,
			visitorId: null,
			timestamp: new Date().toISOString(),
				ip: sessionInfo?.ip || null,
				userAgent: sessionInfo?.userAgent || null,
			};

		logBatch.push(event);
		console.debug('logBatch', logBatch);
		const currentBatchSize = new Blob([JSON.stringify(logBatch)]).size;
		if (currentBatchSize >= SIZE_THRESHOLD_BYTES) {
			sendLogsToServer();
		}
	};
}
export function sendLogsToServer() {
	if (logBatch.length === 0) return;

	const data = JSON.stringify(logBatch);
	const sent = navigator.sendBeacon('https://api.andme.org/logs/collect', data);
	if (sent) {
		logBatch = [];
	}
}

export function getCurrentUserIP(): Promise<string> {
	return fetch('https://api.ipify.org?format=json')
		.then(response => response.json())
		.then(data => {
			const ipAddress = data.ip;
			console.debug('Your IP Address', ipAddress);
			return ipAddress;
		})
		.catch(error => console.error('Error:', error));
}